<template>
  <div class="animated fadeIn" id="iframediv">
    <iframe width="100%" height="100%" :src="src" style="border-width: 0px;"></iframe>
  </div>
</template>

<script>
export default {
  name: "pagella",
  mixins: [window.myMixin],
  components: {},
  data: function() {
    return {};
  },
  computed: {
    src() {
      if(window.DEBUG)
        return "https://swone/AnteprimaGiustificazioni.php?corsid=" + this.getCorsID() + "&schema=" + this.getSchema() + "&g=" + this.getGenitore()
      else if(window.ENAC)
        return "https://swone.cfpcanossa.it/AnteprimaGiustificazioni.php?corsid=" + this.getCorsID() + "&schema=" + this.getSchema()
      else
        return "https://swone.ecfop.it/AnteprimaGiustificazioni.php?corsid=" + this.getCorsID() + "&schema=" + this.getSchema() + "&g=" + this.getGenitore()
    },
  },
  methods: {},
  mounted: function() {
    console.log("def");
    document.getElementById("iframediv").parentNode.classList.add("h100");
  }
};
</script>

<style>
div.h100 {
  height: calc(100% - 80px);
}
</style>
<style scoped>
div.animated {
  height: 100%;
}
</style>
